import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Flex,
  Text,
  useBreakpointValue
} from "@chakra-ui/react";
import { memo } from "react";

import { useConfig } from "src/hooks";

interface Props {
  t: (key: string) => string;
  type: string;
}

const FAQSection = ({ t, type }: Props) => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const { addSuffixCountry } = useConfig();
  const faTransKey = addSuffixCountry("price_selection");

  const faqs: Array<number> = [0, 1, 2];
  return (
    <Flex direction="column" mb={isMobile ? "200px" : 0} mt="30px">
      <Text
        fontWeight="bold"
        fontSize="2xl"
        py={4}
        textAlign="center"
        borderTop="1px solid"
        borderTopColor="primaryTwo.500"
      >
        {t("price_selection:frequently-asked-title")}
      </Text>
      <Accordion allowToggle>
        {faqs.map((index) => (
          <AccordionItem
            key={index}
            borderTopColor="primaryTwo.500"
            borderBottomColor="primaryTwo.500"
          >
            <AccordionButton p="20px 0px">
              <Flex flex="1" textAlign="left">
                <Text fontWeight="bold">{t(`${faTransKey}:FAQ-${type}.${index}.question`)}</Text>
              </Flex>
              <AccordionIcon fontSize="lg" boxSize={6} />
            </AccordionButton>
            <AccordionPanel pb={4} pl={0}>
              {t(`${faTransKey}:FAQ-${type}.${index}.answer`)}
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </Flex>
  );
};

export default memo(FAQSection);
